<template>
	<div class="font-sans">
		<!-- ── Filters bar ── -->
		<div
			class="flex flex-col md:flex-row items-start md:items-center justify-between gap-4 mb-6">
			<div class="w-full md:w-72">
				<SearchForm @search="handleSearch" />
			</div>
			<div class="flex flex-wrap items-center gap-3">
				<RadioFilter @filter="handleRadioFilter" />
				<DropDownFilter
					:datas="categories"
					field="Status"
					label="Filter"
					@filter="handleCheckBoxFilter" />
			</div>
		</div>

		<!-- ── Table ── -->
		<div
			v-if="filteredCategories && filteredCategories.length > 0"
			class="overflow-x-auto rounded-xl border border-primary-100 dark:border-dark-600">
			<table class="w-full border-separate border-spacing-0">
				<thead>
					<tr>
						<th
							v-for="h in ['Category Name']"
							:key="h"
							class="text-left text-[11px] font-bold uppercase tracking-widest px-4 py-3 text-muted dark:text-muted-light bg-primary-50 dark:bg-dark-600 border-b border-primary-100 dark:border-dark-500 whitespace-nowrap">
							{{ h }}
						</th>
						<!-- <th
							class="text-center text-[11px] font-bold uppercase tracking-widest px-4 py-3 text-muted dark:text-muted-light bg-primary-100 dark:bg-dark-500 border-b border-primary-100 dark:border-dark-500 whitespace-nowrap">
							Action
						</th> -->
					</tr>
				</thead>
				<tbody>
					<tr
						v-for="category in filteredCategories"
						:key="category.ID"
						class="hover:bg-primary-50 dark:hover:bg-dark-600/50 transition-colors duration-150">
						<td
							class="px-4 py-3.5 text-[13px] font-semibold text-dark-700 dark:text-white border-b border-primary-50 dark:border-dark-600 whitespace-nowrap">
							{{ category.name }}
						</td>
						<!-- <td
							class="px-4 py-3.5 border-b border-primary-50 dark:border-dark-600 whitespace-nowrap">
							<span
								class="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-[11px] font-semibold"
								:class="
									category.Status === 'active' || category.Status === true
										? 'bg-primary-50 dark:bg-primary-400/15 text-primary-600 dark:text-primary-300'
										: 'bg-dark-100 dark:bg-dark-600 text-muted dark:text-muted-light'
								">
								<span
									class="w-1.5 h-1.5 rounded-full"
									:class="
										category.Status === 'active' || category.Status === true
											? 'bg-primary-400'
											: 'bg-muted'
									" />
								{{ category.Status }}
							</span>
						</td> -->
						<!-- <td
							class="px-4 py-3.5 text-[13px] text-muted dark:text-muted-light border-b border-primary-50 dark:border-dark-600 whitespace-nowrap">
							{{ $formatDate(category.CreatedAt) }}
						</td> -->
						<!-- <td
							class="px-4 py-3.5 text-center border-b border-primary-50 dark:border-dark-600">
							<button
								@click="showOrderDetails(category)"
								class="action-btn hover:bg-primary-100 dark:hover:bg-dark-500 hover:text-primary-600 dark:hover:text-primary-300"
								aria-label="View details">
								<svg class="w-4 h-4" viewBox="0 0 20 20" fill="currentColor">
									<path d="M10 12.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z" />
									<path
										fill-rule="evenodd"
										d="M.664 10.59a1.651 1.651 0 0 1 0-1.186A10.004 10.004 0 0 1 10 3c4.257 0 7.893 2.66 9.336 6.41.147.381.146.804 0 1.186A10.004 10.004 0 0 1 10 17c-4.257 0-7.893-2.66-9.336-6.41ZM14 10a4 4 0 1 1-8 0 4 4 0 0 1 8 0Z"
										clip-rule="evenodd" />
								</svg>
							</button>
						</td> -->
					</tr>
				</tbody>
			</table>
		</div>

		<!-- ── Empty state ── -->
		<div
			v-else
			class="flex flex-col items-center justify-center py-16 gap-3 rounded-card border border-primary-100 dark:border-dark-600">
			<div
				class="w-12 h-12 rounded-2xl bg-primary-50 dark:bg-dark-600 flex items-center justify-center">
				<svg
					class="w-6 h-6 text-muted dark:text-muted-light"
					fill="none"
					stroke="currentColor"
					viewBox="0 0 24 24">
					<path
						stroke-linecap="round"
						stroke-linejoin="round"
						stroke-width="2"
						d="M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l7 7a2 2 0 010 2.828l-7 7a2 2 0 01-2.828 0l-7-7A1.994 1.994 0 013 12V7a4 4 0 014-4z" />
				</svg>
			</div>
			<p
				class="font-display font-bold text-[14px] text-dark-700 dark:text-white">
				No categories found
			</p>
		</div>

		<!-- ══ Category Detail Modal ══ -->
		<transition name="modal">
			<div
				v-if="selectedCategory"
				class="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center p-4 z-50"
				@click.self="selectedCategory = null">
				<div
					class="bg-surface dark:bg-dark-700 rounded-card shadow-dropdown w-full max-w-lg border border-primary-100 dark:border-dark-600">
					<!-- Header -->
					<div
						class="flex items-center justify-between p-6 border-b border-primary-100 dark:border-dark-600">
						<div>
							<p
								class="text-[10px] font-bold uppercase tracking-widest text-muted dark:text-muted-light mb-0.5">
								Category Details
							</p>
							<h2
								class="font-display text-[15px] font-bold text-dark-700 dark:text-white">
								{{ selectedCategory.name }}
							</h2>
						</div>
						<button
							@click="selectedCategory = null"
							class="w-8 h-8 rounded-xl bg-primary-50 dark:bg-dark-600 flex items-center justify-center text-muted dark:text-muted-light hover:bg-primary-100 dark:hover:bg-dark-500 transition-colors duration-150">
							<svg
								class="w-4 h-4"
								fill="none"
								stroke="currentColor"
								viewBox="0 0 24 24">
								<path
									stroke-linecap="round"
									stroke-linejoin="round"
									stroke-width="2.5"
									d="M6 18L18 6M6 6l12 12" />
							</svg>
						</button>
					</div>

					<!-- Info -->
					<div class="p-6 space-y-3">
						<div
							class="flex items-center justify-between py-2.5 px-3 rounded-xl bg-primary-50/60 dark:bg-dark-600/60 border border-primary-100 dark:border-dark-500">
							<span
								class="text-[12px] font-bold uppercase tracking-widest text-muted dark:text-muted-light">
								Status
							</span>
							<span
								class="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-[11px] font-semibold"
								:class="
									selectedCategory.Status === 'active' ||
									selectedCategory.Status === true
										? 'bg-primary-50 dark:bg-primary-400/15 text-primary-600 dark:text-primary-300'
										: 'bg-dark-100 dark:bg-dark-600 text-muted dark:text-muted-light'
								">
								{{ selectedCategory.Status }}
							</span>
						</div>
						<div
							class="flex items-center justify-between py-2.5 px-3 rounded-xl bg-primary-50/60 dark:bg-dark-600/60 border border-primary-100 dark:border-dark-500">
							<span
								class="text-[12px] font-bold uppercase tracking-widest text-muted dark:text-muted-light">
								Created
							</span>
							<span
								class="text-[13px] font-medium text-dark-700 dark:text-white">
								{{ selectedCategory.CreatedAt }}
							</span>
						</div>
					</div>

					<!-- Update status -->
					<div class="px-6 pb-6">
						<p
							class="text-[11px] font-bold uppercase tracking-widest text-muted dark:text-muted-light mb-3">
							Update Status
						</p>
						<div
							class="flex flex-col md:flex-row items-stretch md:items-center gap-3">
							<select
								v-model="selectedCategory.status"
								@change="updateOrderStatus"
								class="flex-1 px-3.5 py-2.5 rounded-xl text-[13px] font-medium bg-primary-50/60 dark:bg-dark-600 border border-primary-100 dark:border-dark-500 text-dark-700 dark:text-white outline-none focus:border-primary-400 focus:ring-2 focus:ring-primary-400/20 transition-all">
								<option value="pending">Pending</option>
								<option value="processing">Processing</option>
								<option value="completed">Completed</option>
								<option value="cancelled">Cancelled</option>
							</select>
							<button
								@click="confirmDeleteOrder"
								class="inline-flex items-center justify-center gap-2 px-4 py-2.5 rounded-xl text-[13px] font-bold text-red-500 bg-red-50 dark:bg-red-950/30 border border-red-200 dark:border-red-800/50 hover:bg-red-100 dark:hover:bg-red-950/50 transition-colors whitespace-nowrap">
								<svg
									class="w-4 h-4"
									fill="none"
									stroke="currentColor"
									viewBox="0 0 24 24">
									<path
										stroke-linecap="round"
										stroke-linejoin="round"
										stroke-width="2"
										d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
								</svg>
								Delete
							</button>
						</div>
					</div>
				</div>
			</div>
		</transition>
	</div>
</template>

<script>
import SearchForm from "@/components/SearchForm.vue";
import RadioFilter from "./RadioFilter.vue";
import DropDownFilter from "./DropDownFilter.vue";
import { apiDataService } from "@/services/apiDataService";
import { useToast } from "vue-toast-notification";
import "vue-toast-notification/dist/theme-sugar.css";

export default {
	name: "CategoryListing",
	components: { SearchForm, RadioFilter, DropDownFilter },
	props: { categories: { type: Array, required: true, default: () => [] } },
	data() {
		return {
			searchFilter: "",
			radiofilterVariable: "",
			statusesFilter: [],
			selectedCategory: 0,
			toast: useToast(),
		};
	},
	methods: {
		handleSearch(search) {
			this.searchFilter = search;
		},
		handleRadioFilter(filter) {
			this.radiofilterVariable = filter;
		},
		handleCheckBoxFilter(filters) {
			this.statusesFilter = Array.isArray(filters) ? filters : [filters];
		},
		showOrderDetails(category) {
			this.selectedCategory = category;
		},
		async updateOrderStatus() {
			try {
				const response = await apiDataService.updateCategory({
					status: this.selectedCategory.Status,
					orderId: this.selectedCategory.id,
				});
				this.toast.success("Order updated successfully!", {
					position: "top-right",
					duration: 3000,
				});
				this.$emit("status-updated", {
					orderId: this.selectedCategory.id,
					newStatus: this.selectedCategory.status,
				});
				window.location.reload();
				console.log("Order status updated:", response);
			} catch (error) {
				this.toast.error("Failed to update. Please try again.", {
					position: "top-right",
					duration: 5000,
				});
			}
		},
		async confirmDeleteOrder() {
			if (confirm("Do you want to proceed?"))
				this.deleteOrder(this.selectedCategory.id);
		},
		async deleteOrder(orderId) {
			try {
				await apiDataService.deleteOrder(orderId);
				this.toast.success("Order deleted successfully", {
					position: "top-right",
					duration: 5000,
				});
				window.location.reload();
				this.$emit("order-deleted", orderId);
			} catch (error) {
				this.toast.error("Failed to delete order. Please try again.", {
					position: "top-right",
					duration: 5000,
				});
			}
		},
	},
	computed: {
		filteredCategories() {
			let categories = this.categories;
			switch (this.radiofilterVariable) {
				case "today": {
					const today = new Date();
					categories = categories.filter(
						(c) =>
							new Date(c.CreatedAt).toDateString() === today.toDateString(),
					);
					break;
				}
				case "past": {
					const now = new Date();
					categories = categories.filter((c) => new Date(c.CreatedAt) < now);
					break;
				}
			}
			if (this.statusesFilter.length > 0)
				categories = categories.filter((c) =>
					this.statusesFilter.includes(String(c.Status)),
				);
			if (this.searchFilter) {
				const term = this.searchFilter.toLowerCase();
				categories = categories.filter((c) =>
					String(c.Name).toLowerCase().includes(term),
				);
			}
			return categories;
		},
	},
};
</script>

<style scoped>
.action-btn {
	@apply flex items-center justify-center w-8 h-8 rounded-xl
         text-muted dark:text-muted-light
         bg-primary-50 dark:bg-dark-600
         transition-all duration-200;
}
.modal-enter-active,
.modal-leave-active {
	transition: opacity 0.2s ease;
}
.modal-enter-from,
.modal-leave-to {
	opacity: 0;
}
</style>
